import * as moment from 'moment-timezone';
import * as React from 'react';
import { Button, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import OpenArrow from 'src/Components/OpenArrow/OpenArrow';
import { IDispatchConfirm, IDispatchTruck } from 'src/Interfaces/DispatchInterface';
import { ReceiveDispatchTable } from './ReceiveDispatchTable';


const boldStyle = {
    fontWeight: 700
};

interface IDispatchReceiveProps {
    dispatch: IDispatchConfirm[] | undefined;
    type: string;
    isOpen: boolean;
    toggleOpen: () => void;
    onReceive: (dispatchTruck: IDispatchTruck, dispatchIndex: number, truckIndex: number) => void;
}

export class ReceiveDispatchModal extends React.Component {
    public props: IDispatchReceiveProps;

    public state = {
        dispatchTruckOpen: [] as boolean[][],
    };

    constructor(props: any) {
        super(props);
    }

    private handleTruckOpen = (dispatchIndex: number, index: number) => () => {
        const dispatchTruckOpen = this.state.dispatchTruckOpen;
        if(!Array.isArray(dispatchTruckOpen[dispatchIndex])) {
            dispatchTruckOpen[dispatchIndex] = [];
        }
        dispatchTruckOpen[dispatchIndex][index] = !dispatchTruckOpen[dispatchIndex][index];
        this.setState({dispatchTruckOpen});
    }

    private handleReceive = (dispatchTruck: IDispatchTruck, dispatchIndex: number, truckIndex: number) => () => {
        this.props.onReceive(dispatchTruck, dispatchIndex, truckIndex);
    }

    public render() {
        if (!this.props.dispatch) {
            return '';
        }
        const { isOpen, toggleOpen } = this.props;
        const dispatch = this.props.dispatch;
        return <Modal size="lg" isOpen={isOpen} toggle={toggleOpen}>
            <ModalHeader toggle={toggleOpen}>
                Acknowledge Trucks for {this.props.type}
            </ModalHeader>
            <ModalBody>
                {
                    dispatch.map((d, dind) => <React.Fragment key={d.id}>
                     <Row>
                        <Col>
                            <h3 style={boldStyle}>Submitted Test Date:</h3>
                        </Col>
                        <Col>
                            <h3>
                                { 
                                d.submittedWellTest
                                ? moment.unix(d.submittedWellTest.testDate).format("MMM DD YYYY")
                                : 'Spud Load'}
                            </h3>
                        </Col>
                    </Row>

                    {
                        d.trucks.map((dt, index) => 
                        <React.Fragment key={dt.id === '' ? index : dt.id}>
                            <h4 style={boldStyle}>
                                <Row>
                                    <Col>
                                            <span onClick={this.handleTruckOpen(dind, index)}>
                                                <OpenArrow open={this.state.dispatchTruckOpen[dind] && this.state.dispatchTruckOpen[dind][index]} />
                                            </span>
                                            Truck {dt.ordinal}:
                                            {' '}
                                            Current Status: {dt.status}
                                            {' '}
                                            
                                    </Col>
                                    {
                                        this.props.type === "Delivery" && dt.status === 'Delivered' &&
                                        <Col>
                                            <Button color="primary" onClick={this.handleReceive(dt, dind, index)}>Receive Truck</Button>
                                        </Col>
                                    }
                                    {
                                        this.props.type === "Pick Up" && !dt.returnedWellTestId && !dt.returnedWellCloseReviewId &&
                                        <Col>
                                            <Button color="primary" onClick={this.handleReceive(dt, dind, index)}>Acknowledge Pickup</Button>
                                        </Col>
                                    }
                                </Row>
                            </h4>
                            {
                                this.state.dispatchTruckOpen[dind] && this.state.dispatchTruckOpen[dind][index] && 
                                <Row>
                                    <Col>
                                        <ReceiveDispatchTable dispatchTruck={dt} />
                                    </Col>
                                </Row>
                            }
                        </React.Fragment>
                        )
                    }
                    </React.Fragment>
                    )
                }
            </ModalBody>
        </Modal>;
    }

}


// WEBPACK FOOTER //
// ./src/Components/Main/Dispatch/ReceiveDispatch/ReceiveDispatchModal.tsx